import { Link } from 'react-router-dom';
import './ButtonLink.css';
import React from 'react';

// const link = '/';
const classname = 'button_link';

// todo  'button__link_panel-bg' change background
interface ButtonLinkProps {
    icon?: React.ReactNode;
    link?: string;
}
export const ButtonLink: React.FC<ButtonLinkProps> = ({ link, icon }) => {
    return (
        <Link to={link || ''} className="button__link">
            {icon && icon}
        </Link>
    );
};
